const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/user/change-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { UserChangeLogFilterParamSchema } from '@apps/main/features/admin/pages/user/change-log-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/user/change-log')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: UserChangeLogFilterParamSchema
});